<div class="container" [class.mobile]="isMobile">
  <div *ngIf="!isAdmin">
    <div class="tabs">
      <div class="tab" [class.active]='currentCategory === PictureCategories.Villa'
        (click)="switchCategory(PictureCategories.Villa)">
        <i class="fa fa-home"></i>&nbsp;
        {{'Villa Skalaki' | translate}}
      </div>
      <div class="tab" [class.active]='currentCategory === PictureCategories.Surroundings'
        (click)="switchCategory(PictureCategories.Surroundings)">
        <i class="fa fa-map-marker-alt"></i>&nbsp;
        {{'Alentours' | translate}}
      </div>
      <div class="tab" [class.active]='currentCategory === PictureCategories.East'
        (click)="switchCategory(PictureCategories.East)">
        <i class="far fa-compass"></i>&nbsp;
        {{"Crète de l'Est" | translate}}
      </div>
    </div>
    <div class="columns" [class.columns-tablet]="isTablet" [class.columns-mobile]="isMobile">
      <div class="picture-container" *ngFor="let picture of pictures | async; index as i;">
        <img [src]="picture.thumbPath" alt="thumb" [hidden]="!picture.loaded" (load)="picture.loaded = true"
          class="picture" (click)="preview(picture.id)">
        <div [style.height]="picture.thumbHeight + 'px'" *ngIf="!picture.loaded">
          <app-picture-loading>
          </app-picture-loading>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isAdmin" class="admin-container">
    <div class="tabs">
      <div class="tab" [class.active]='currentCategory === PictureCategories.Villa'
        (click)="switchCategory(PictureCategories.Villa)">
        <i class="fa fa-home"></i>&nbsp;
        {{'Villa Skalaki' | translate}}
      </div>
      <div class="tab" [class.active]='currentCategory === PictureCategories.Surroundings'
        (click)="switchCategory(PictureCategories.Surroundings)">
        <i class="fa fa-map-marker-alt"></i>&nbsp;
        {{'Alentours' | translate}}
      </div>
      <div class="tab" [class.active]='currentCategory === PictureCategories.East'
        (click)="switchCategory(PictureCategories.East)">
        <i class="far fa-compass"></i>&nbsp;
        {{"Crète de l'Est" | translate}}
      </div>
    </div>
    <div class="add-picture">
      <button class="wire-btn skalaki" (click)="editPicture(null, templateCreate)">Add picture<i
          class="fa fa-plus"></i></button>
    </div>
    <table class="pic-table">
      <thead>
        <th id="order">
          Order
        </th>
        <th id="dName">
          Name
        </th>
        <th id="Pic">
          Picture
        </th>
        <th id="UpdatedAt">
          Updated At
        </th>
        <th id="Actions">
          Actions
        </th>
      </thead>
      <tbody>
        <tr *ngFor="let picture of pictures | async; index as i;">
          <td>
            {{picture.order}}
          </td>
          <td>
            {{picture.displayName}}
          </td>
          <td>
            <img [src]="picture.thumbPath" [hidden]="!picture.loaded" alt="img" height="75px"
              (load)="picture.loaded = true" />
            <img src="../../assets/loading.gif" alt="img" height="75px" *ngIf="!picture.loaded">
          </td>
          <td>
            {{picture.updatedAt | date:'dd/MM/yyyy HH:mm'}}
          </td>
          <td>
            <div class="actions">
              <button class="wire-btn skalaki" (click)="editPicture(picture, templateCreate)">Edit<i
                  class="fa fa-pencil-alt"></i></button>
              <button class="wire-btn" (click)="deletePicture(picture)">Delete<i class="fa fa-trash-alt"></i></button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-preview *ngIf="isPreview"></app-preview>

<ng-template #templateCreate>
  <div class="modal-content">
    <div class="header">
      {{pictureModel.id ? 'Update' : 'Add'}} picture
    </div>
    <div class="content">
      <div class="form">
        <div class="form-group">
          <div class="label">
            Name
          </div>
          <input type="text" [(ngModel)]="pictureModel.displayName" name="displayName" #displayName="ngModel" />
        </div>
        <div class="form-group" *ngIf="!pictureModel.id">
          <div class="label">Picture File</div>
          <input type="file" required class="form-control-file" id="pictureBinary" (change)="onFileChange($event)"
            name="pictureFile" />
        </div>
        <div class="form-group" *ngIf="pictureModel.id">
          <div class="label" for="pictureOrder">Order</div>
          <input type="number" required [(ngModel)]="pictureModel.order" #pictureOrder="ngModel" name="pictureOrder"
            id="pictureOrder" />
          <div *ngIf="pictureOrder.invalid && (pictureOrder.dirty || pictureOrder.touched)" class="alert alert-danger">
            Picture Order is required
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="wire-btn" (click)="savePicture()">Save <i *ngIf="loadingPictureSave"
          class="fa fa-spinner"></i></button>
      <button class="wire-btn default" (click)="modalRef.hide()">Cancel</button>
    </div>
  </div>
</ng-template>

<p-confirmDialog header="Delete Picture" icon="pi pi-exclamation-triangle"></p-confirmDialog>